import React, { useEffect, useRef, useState } from "react";
import "./QuestionType.css";
import ImgType from "./ImgType";
import CameraType from "./CameraType";
import TextareaType from "./TextareaType";
import PdfType from "./PdfType";
import VideoType from "./VideoType";
import CheckBoxType from "./CheckBoxType";
import SucessfullySubmited from "./SucessfullySubmited";
import SubmisshionByUpload from "./SubmisshionByUpload";
import { AiOutlineClockCircle } from "react-icons/ai";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import {
  useNavigate,
  useParams,
  useHistory,
  useLocation,
} from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import useUnsavedChangesWarning from "./useUnsavedChangesWarning";
import ExitFullScreenPopup from "./ExitFullScreenPopup";
import SubmittingWithoutAnsweringPopup from "./SubmittingWithoutAnsweringPopup";
import MandetoryUnAnsweredPopup from "./mandetoryUnAnsweredPopup";
import UnAuthAssessmentPopup from "./UnAuthAssessmentPopup";
import AssAlreadyAnsPopup from "./AssAlreadyAnsPopup";
import { AdaptiveQuiz } from "../../Completed/irt";
import { toast } from "react-toastify";
import VerticalProBarPending from "../VerticalProBarPending";
import ConfirmationPopup from "./ConfirmationPopup";

export default function AllQuestions({
  assessmentId: propAssessmentId,
  handleQuestionfalse,
}) {
  const warnedRef = useRef(false);
  const { state } = useLocation();
  const [difficulty, setDifficulty] = useState(0);
  const [ability, setAbility] = useState(0);
  const { assessmentId: paramsAssessmentId } = useParams();
  const [didPressExit, setDidPressExit] = useState(false);
  const [unAnsweredPopup, setUnAnsweredPopup] = useState(false);
  const [mandetoryPopup, setMandetoryPopup] = useState(false);
  const [unAuthPopup, setUnAuthPopup] = useState(false);
  const [responseAnswers, setResponseAnswers] = useState([]);
  const [checkQuestion, setCheckQuestion] = useState(false);
  const [skillsValue, setSkillsValue] = useState("");
  const [autoEvaluated, setAutoEvaluated] = useState(false);
  const [unAttemptedQsArray, setUnAttemptedQsArray] = useState([]);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);

  // const history = useHistory();

  const assessmentId = propAssessmentId || paramsAssessmentId;
  const isFromDCM = localStorage.getItem("from");
  const navigate = useNavigate();

  // const handleCheckboxChanges = (isChecked) => {
  //   setCheckQuestion(isChecked);
  // };

  const handleBack = () => {
    if (handleQuestionfalse) {
      handleQuestionfalse();
    } else if (isFromDCM === "DCM") {
      navigate("/Calender");
    } else {
      // console.log("isFromDCM : 555 ")
      navigate("/Assessment");
    }
  };
  const refreshPage = () => {
    // debugger;
    setTimeout(() => navigate("/Assessment"), 1000);
  };

  const list = [
    {
      type: "Checkbox Type",
    },
    {
      type: "Camera Type",
    },
    {
      type: "Img Type",
    },
    {
      type: "Video Type",
    },
    {
      type: "Pdf Type",
    },
    {
      type: "TextArea Type",
    },
    {
      type: "Upload Type",
    },
  ];
  const [pendingData, setPendingData] = useState();
  const [isGettingData, setIsGettingData] = useState(true);
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const [questionsAnswer, setQuestionsAnswer] = useState([]);
  const [seconds, setSeconds] = useState();
  const [adaptive, setAdaptive] = useState(false);
  const [unAnsweredQs, setUnansweredQs] = useState([]);
  // const [questionNo, setQuestionNo] = useState(0);
  const [questionNo, setQuestionNo] = useState(
    pendingData?.adaptiveQuiz?.currentQuestion?.no || 0,
  );
  const [allQuestion, setAllQuestion] = useState({
    sucessful: false,
  });
  const [openstartAssesmentPopup, setOpenstartAssesmentPopup] = useState(false);
  const [errMsg, setErrMsg] = useState("Something went Wrong!");
  const [openBlurPopup, setOpenBlurPopup] = useState(false);
  //
  useEffect(() => {
    setOpenstartAssesmentPopup(true);
  }, []);

  const checkUnanswered = () => {
    // current question pick karo
    const currentQuestion = questionsAnswer[questionNo];

    const pendingCurrentQs = pendingData?.questions[questionNo];

    setUnAttemptedQsArray((prev) => [
      ...prev,
      {
        id: pendingCurrentQs?.id,
        title: `Q${questionNo + 1}. ${pendingCurrentQs?.title}`,
      },
    ]);

    if (
      currentQuestion?.answer?.key === " " ||
      currentQuestion?.answer?.key === "" ||
      currentQuestion?.description === " " ||
      currentQuestion?.description === ""
    ) {
      setUnansweredQs((prev) => [...prev, currentQuestion]);
    } else {
      setUnansweredQs((prev) =>
        prev.filter((q) => q.index !== currentQuestion.index),
      );
    }
  };

  const unAttemptedTitles = unAttemptedQsArray
    .filter((item) => unAnsweredQs.some((q) => q.question_id === item.id))
    .map((item) => item.title);

  // useEffect(() => {
  //   const confirmExit = (e) => {
  //     const message = "Are you sure you want to leave?";
  //     e.returnValue = message;
  //     return message;
  //   };

  //   window.addEventListener("beforeunload", confirmExit);

  //   return () => {
  //     window.removeEventListener("beforeunload", confirmExit);
  //   };
  // }, []);

  // const [Prompt, setFalse] = useUnsavedChangesWarning();
  let data = JSON.parse(localStorage.getItem("breathForStudent"));
  const difficultyLevels = ["Very Hard", "Hard", "Medium", "Easy", "Very Easy"];
  const skillsLevels = [
    "Create",
    "Evalute",
    "Analyze",
    "Apply",
    "Understand",
    "Remember",
  ];

  const handleFullscreenChange = () => {
    const isFullScreen = document.fullscreenElement;
    const videoPlayer = document.querySelector(".videoPlayer");
    if (!isFullScreen) {
      const element = document.getElementById("fullScreenContent");
      try {
        // element.requestFullscreen();
        setDidPressExit(true);
      } catch (error) {
        console.error("Failed to re-enter fullscreen mode:", error);
      }
    }
  };

  const toggleFullScreen = () => {
    const element = document.getElementById("fullScreenContent");
    if (element && !document.fullscreenElement) {
      element.requestFullscreen().catch((err) => {
        console.error("Failed to enter fullscreen:", err);
      });
    }

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Disable keyboard shortcuts
    const handleKeyDown = (e) => {
      // Block Ctrl/Cmd + C,V,X,S,P,A
      if (e.ctrlKey || e.metaKey) {
        const blocked = ["c", "v", "x", "s", "p", "a"];
        if (blocked.includes(e.key.toLowerCase())) e.preventDefault();
      }

      // Block F12, F5
      if ([116, 123].includes(e.keyCode)) e.preventDefault();

      // Optional: Block other shortcuts if needed
    };
    document.addEventListener("keydown", handleKeyDown);
  };

  useEffect(() => {
    const handleBlur = () => {
      setDidPressExit(true);
    };
    window.addEventListener("blur", handleBlur);
    return () => window.removeEventListener("blur", handleBlur);
  }, []);

  function getCurrentTime() {
    const currentTime = new Date();
    const hours = String(currentTime.getHours()).padStart(2, "0");
    const minutes = String(currentTime.getMinutes()).padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`;
    return formattedTime;
  }
  useEffect(async () => {
    try {
      await axios.put(
        `/assessment/UpdateStartedFlag/assessmentId/${assessmentId}/studentId/${data.id}`,
        {
          started_flag: "true",
          currentStatus: "Started",
          startTime: getCurrentTime(),
        },
      );
    } catch (error) {
      console.log(error);
    }
  }, []);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleSucessfulyfalse = () => {
    setAllQuestion({
      ...allQuestion,
      sucessful: false,
    });
  };
  function calculateTimeDifference(time1, time2, thresholdMinutes) {
    if (time1 && time2) {
      const [hours1, minutes1] = time1.split(":").map(Number);
      const [hours2, minutes2] = time2.split(":").map(Number);
      const totalMinutes1 = hours1 * 60 + minutes1;
      const totalMinutes2 = hours2 * 60 + minutes2;
      let difference = totalMinutes2 - totalMinutes1;
      if (difference < 0) {
        difference += 24 * 60;
      }
      return difference < thresholdMinutes ? difference : thresholdMinutes;
    }
  }

  useEffect(() => {
    const getStudentResponse = async () => {
      let updatedQuestion = [];
      try {
        let res = await axios.get(`/assessment/getForStudent/${assessmentId}`);

        res &&
          res.data.data?.questions.forEach((question, index) => {
            if (!question.type.is_manually_graded) {
              updatedQuestion.push({
                question_id: question?.id,
                answer: {
                  key: " ",
                  explanation: " ",
                },
                mandatory: question?.is_mandatory,
                index,
              });
            } else {
              updatedQuestion.push({
                question_id: question?.id,
                description: " ",
                mandatory: question?.is_mandatory,
                index,
              });
            }
          });
        setQuestionsAnswer([...updatedQuestion]);
        // setPendingData(res.data.data);
        setAutoEvaluated(res?.data?.data?.autoEvalEnabled);

        if (res.data.data?.isAdaptive) {
          let responsedata = res.data.data;
          try {
            responsedata.adaptiveQuiz = new AdaptiveQuiz(
              responsedata?.id,
              data.id,
              responsedata?.questions,
              setAbility,
              setDifficulty,
              responsedata.total_questions,
            );
            responsedata?.adaptiveQuiz.startQuiz();
            //  setQuestionNoAdaptive(true);
            setAdaptive(true);
            setPendingData(responsedata);
          } catch (error) {
            // console.error("Failed to initialize AdaptiveQuiz:", error);
          }
        } else {
          setPendingData(res.data.data);
        }

        // TBD: modify below to use set remaining seconds (current_time - (start_time+ total_duration))
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
        setUnAuthPopup(true);
        setErrMsg(error.response.data.message);
      }
    };
    getStudentResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const fetchStudentDetails = async () => {
      try {
        let res1 = await axios.get(
          `/assessment/studentAssessment/getByAssessmentId/${assessmentId}?student_id=${data.id}`,
        );
        if (res1) {
          let assessemntData = res1.data.data[0];
          let currentTime = getCurrentTime();
          let timeToDisplay = res1?.data?.data[0]?.revisedEndTime
            ? calculateTimeDifference(
                currentTime,
                res1?.data?.data[0]?.revisedEndTime,
                res1?.data?.data[0]?.totalDuration,
              )
            : res1?.data?.data[0]?.totalDuration;
          // setSeconds(60 * timeToDisplay);
          handleTimer(
            assessemntData?.assessment_id?.scheduleTime,
            assessemntData?.assessment_id?.totalDuration,
          );
        }
      } catch (error) {}
    };
    fetchStudentDetails();
  }, []);
  // create for timer
  // const initialSeconds = ;

  useEffect(() => {
    if (seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    } else if (seconds === 0) {
      if (!adaptive) {
        handleSubmit();
      } else {
        handleSubmitAdaptive();
      }
    }
  }, [seconds]);

  useEffect(() => {
    if (seconds <= 0) {
      setNextButtonDisabled(true);
      toast.error("ASSESSMENT ENDED!!");
    } else {
      setNextButtonDisabled(false);
    }
  }, [seconds]);

  const formatTime = (seconds) => {
    if (seconds <= 0) return "00:00";

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleTimer = (scheduleTime, totalDuration) => {
    const [hours, minutes] = scheduleTime.split(":").map(Number);

    const start = new Date();
    start.setHours(hours + 5, minutes + 30, 0, 0);

    const end = new Date(start.getTime() + totalDuration * 60 * 1000);
    // use UTC timestamps to avoid local timezone confusion
    const diffInSeconds = Math.floor((end.getTime() - Date.now()) / 1000);
    setSeconds(diffInSeconds);
    return formatTime(diffInSeconds);
  };

  const handleSubmit = async () => {
    try {
      // setFalse();
      checkUnanswered();
      const descriptive = questionsAnswer.filter((elem) =>
        elem.hasOwnProperty("description"),
      );
      const objective = questionsAnswer.filter((elem) =>
        elem.hasOwnProperty("answer"),
      );
      const descriptiveNotAnswered = descriptive.every(
        (elem) => elem.description.trim() === "",
      );
      const objectiveNotAnswered = objective.every(
        (elem) => elem.answer.key.trim() === "",
      );

      const mandetoryUnAnserted = descriptive.some((elem) =>
        elem.mandatory ? elem.description.trim() === "" : false,
      );

      const objectiveMandetoryNotAnswered = objective.some((elem) =>
        elem.mandatory ? elem.answer.key.trim() === "" : false,
      );

      if (mandetoryUnAnserted || objectiveMandetoryNotAnswered) {
        setMandetoryPopup(true);
        return;
      }

      setIsGettingData(true);
      let res = await axios.post(
        `/assessment/${assessmentId}/studentResponse/create`,
        {
          student_id: userId,
          submitted_on: new Date(),
          answers: questionsAnswer,
        },
      );
      let res1 = await axios.put(
        `/assessment/UpdateStartedFlag/assessmentId/${assessmentId}/studentId/${data.id}`,
        {
          started_flag: "true",
          currentStatus: "Submitted",
          endTime: getCurrentTime(),
        },
      );
      res && setAllQuestion({ ...allQuestion, sucessful: true });
      setIsGettingData(false);
      setTimeout(() => {
        window.close();
      }, 5000);
    } catch (error) {
      console.log(error);
    } finally {
      setIsGettingData(false);
    }
  };

  const handleAutoEvaluatedSubmit = async () => {
    if (unAttemptedTitles.length > 0) {
      setUnAnsweredPopup(true);
      return;
    }
    let results = [];
    try {
      setIsGettingData(true);
      let res = await axios.post(
        `/assessment/${assessmentId}/studentResponse/create`,
        {
          student_id: userId,
          submitted_on: new Date(),
          answers: questionsAnswer,
        },
      );
      let newResult = {
        id: null,
        teacher_id: pendingData.teacher_id.id,
        student_id: data.id,
      };
      res?.data?.data?.answers.map((answer) => {
        const question = pendingData.questions.find(
          (q) => q.id === answer.question_id,
        );
        if (question) {
          const isCorrect = question.correct_answers.some(
            (opt) => opt.option_key === answer?.answer?.key,
          );
          results.push({
            question_response_id: answer.id,
            comment: "AutoEvaluated",
            correct_score: question.correct_score,
            obtained_marks: isCorrect ? Number(question.correct_score) : 0,
          });
        }
      });

      newResult.results = results;

      try {
        // let res = await axios.post(
        //   `/assessment/${assessmentId}/studentResult/create`,
        //   newResult
        // );

        let res1 = await axios.put(
          `/assessment/UpdateStartedFlag/assessmentId/${assessmentId}/studentId/${data.id}`,
          {
            started_flag: "true",
            currentStatus: "Submitted",
            endTime: getCurrentTime(),
          },
        );
        res && setAllQuestion({ ...allQuestion, sucessful: true });
        setIsGettingData(false);
        setTimeout(() => {
          window.close();
        }, 5000);
        // navigate('/onreviewstudentlist', { state: { assessmentId: res?.data?.data?.assessment_id } })
      } catch (error) {
        console.log("error", error);
      }
    } catch (error) {}
  };

  const handleSubmitAdaptive = async () => {
    try {
      setIsGettingData(true);
      let res = await axios.post(
        `/assessment/${assessmentId}/studentResponse/create`,
        {
          student_id: userId,
          submitted_on: new Date(),
          answers: questionsAnswer,
          // adaptiveResult: pendingData.adaptiveQuiz.getFinalResult()
          // adaptive:true,
          // difficultyHistory: pendingData?.adaptiveQuiz.difficultyHistory,
          // correctAnswersCount: pendingData?.adaptiveQuiz.correctAnswersCount,
          // incorrectAnswersCount: pendingData?.adaptiveQuiz.incorrectAnswersCount,
        },
      );

      let status = await handleSubmitResult(res.data.data);
      if (status) {
        let res1 = await axios.put(
          `/assessment/UpdateStartedFlag/assessmentId/${assessmentId}/studentId/${data.id}`,
          {
            started_flag: "true",
            currentStatus: "Submitted",
            endTime: getCurrentTime(),
          },
        );
        const responseData = res?.data?.data;
        setResponseAnswers(responseData);
        if (res) {
          setAllQuestion({ ...allQuestion, sucessful: true });
        }
        setIsGettingData(false);
        setTimeout(() => {
          window.close();
        }, 5000);
      } else {
        toast.error("Error occurred during the submission!");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenConfirmPopup(false);
      setIsGettingData(false);
    }
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, [seconds]);

  const onBackButtonEvent = (e) => {
    seconds !== 0 && e.preventDefault();
  };

  function setQuestionNoAdaptive() {
    let correct_answers = [];
    for (
      let i = 0;
      i < pendingData.adaptiveQuiz.currentQuestion.correct_answers.length;
      i++
    ) {
      correct_answers.push(
        pendingData.adaptiveQuiz.currentQuestion.correct_answers[i].option_key,
      );
    }
    let correct = correct_answers.includes(
      questionsAnswer[pendingData?.adaptiveQuiz?.currentQuestion?.no]?.answer
        ?.key,
    );
    // setCorrectAnswer(correct)

    pendingData?.adaptiveQuiz?.recordAnswer(correct);
    const qNo = pendingData?.adaptiveQuiz?.currentQuestion?.no;
    setQuestionNo(qNo);
  }

  useEffect(() => {
    getDifficultyName(pendingData);
  }, [questionNo, pendingData]);

  const getDifficultyName = (results) => {
    const questionTypeMapSkill = {
      Create: 6,
      Evaluate: 5,
      Analyze: 4,
      Apply: 3,
      Understand: 2,
      Remember: 1,
    };

    if (
      !pendingData?.questions ||
      !pendingData?.adaptiveQuiz?.currentQuestion
    ) {
      return;
    }
    // Find the current question
    const skillsValue =
      questionTypeMapSkill[
        pendingData?.adaptiveQuiz?.currentQuestion?.skill?.name
      ] || 0;
    setSkillsValue(skillsValue);
  };

  const handleSubmitResult = async (responseData) => {
    let results = [];
    let difficulty_history = pendingData.adaptiveQuiz.difficultyHistory.map(
      (item) => ({
        ability: item.ability,
        difficulty: item.difficulty,
        isCorrect: item.isCorrect,
        questionNo: item.questionNo,
      }),
    );

    let newResult = {
      id: null,
      teacher_id: pendingData.teacher_id.id,
      student_id: data.id,
      ability: pendingData.adaptiveQuiz.getDisplayAbility(),
      correct_count: pendingData.adaptiveQuiz.correctAnswersCount,
      incorrect_count: pendingData.adaptiveQuiz.incorrectAnswersCount,
      accuracy: pendingData.adaptiveQuiz.accuracy,
      difficulty_history: difficulty_history, // Add the transformed array here
    };

    responseData.answers.map((answer) => {
      // const ans = pendingData?.adaptiveQuiz.questionPool.find(ans => ans.id === answer.question_id);
      const ans = pendingData?.adaptiveQuiz.answers.find(
        (ans) => ans.question.id === answer.question_id,
      );
      if (ans) {
        results.push({
          question_response_id: answer.id,
          comment: "Adaptive",
          correct_score: ans?.question?.correct_score
            ? ans?.question?.correct_score
            : 0,
          obtained_marks: ans?.correct
            ? Number(ans?.question?.correct_score)
            : 0,
        });
      } else {
        const unattempted = pendingData?.questions.find(
          (q) => q.id === answer.question_id,
        );
        results.push({
          question_response_id: answer.id,
          comment: "Adaptive",
          correct_score: unattempted.correct_score,
          obtained_marks: 0,
        });
      }
    });

    newResult.results = results;

    try {
      let res = await axios.post(
        `/assessment/${assessmentId}/studentResult/create`,
        newResult,
      );
      return true;
      // navigate('/onreviewstudentlist', { state: { assessmentId: res?.data?.data?.assessment_id } })
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (seconds < 120 && !warnedRef.current) {
      toast.warning("2 minutes remaining!!");
      warnedRef.current = true;
    }
  }, [seconds]);

  useEffect(() => {
    // This useEffect will run whenever the difficulty state changes
    // and will update the VerticalProgBar component accordingly.
    // Force re-render by updating a dummy state or using a key prop on VerticalProgBar
  }, [difficulty]);

  return (
    <div className="ContainerQuestion d-flex p-4 gap-1" id="fullScreenContent">
      {/* Hide the back button from assessemnt page */}
      {/* <div>
        <img
          style={{ cursor: "pointer" }}
          // onClick={navigate("/Summary")}
          onClick={handleBack}
          src="/HwImg/backArrow.png"
          alt=""
        />{" "}
        &nbsp;
      </div> */}
      {!unAuthPopup && (
        <div className="hederContainer1">
          <div>
            <div className="d-flex justify-content-between w-100  ">
              <div>
                <span className="text-[20px] font-bold">
                  {pendingData?.name}
                </span>
              </div>
            </div>
            <div
              className="d-flex justify-content-between w-100 mt-1"
              style={{ position: "relative" }}
            >
              <div>
                <span className="text-17px font-semibold">
                  {pendingData?.subject_id?.name}
                </span>
                &nbsp;
                <span>|</span> &nbsp;
                <span className="text-17px font-semibold">Scheduled</span>{" "}
                &nbsp;
                <span className="text-17px font-semibold">
                  {timeHelper(pendingData?.schedule_date)}
                </span>
                &nbsp;
                {adaptive && (
                  <span
                    style={{
                      padding: "7px 12px",
                      position: "absolute",
                      top: "-7px",
                      left: "800px",
                      borderRadius: "6px",
                    }}
                  >
                    <img
                      src="/images/adaptiveImg.png"
                      alt="img"
                      style={{ width: "100px" }}
                    />
                  </span>
                )}
                {pendingData?.autoEvalEnabled && (
                  <span
                    style={{
                      padding: "0px 12px",
                      position: "absolute",
                      top: "-17px",
                      left: "800px",
                      borderRadius: "6px",
                    }}
                  >
                    <img
                      src="/images/auto-eva.png"
                      alt="img"
                      style={{ width: "90px" }}
                    />
                  </span>
                )}
              </div>
              <div className="d-flex gap-3 align-items-center">
                <div className="subTitle2">
                  <AiOutlineClockCircle /> &nbsp;
                  {seconds < "120" ? (
                    <span className="text-red-700">{formatTime(seconds)}</span>
                  ) : (
                    formatTime(seconds)
                  )}
                </div>
                {!adaptive && !autoEvaluated && (
                  <button
                    disabled={nextButtonDisabled}
                    className="nextBtnQue"
                    onClick={() => {
                      setOpenConfirmPopup(true);
                    }}
                  >
                    Submit
                  </button>
                )}
                {autoEvaluated && (
                  <button
                    disabled={nextButtonDisabled}
                    className="nextBtnQue"
                    onClick={() => {
                      setOpenConfirmPopup(true);
                    }}
                  >
                    Submit
                  </button>
                )}
                {adaptive &&
                  pendingData?.adaptiveQuiz?.usedQuestions?.length ===
                    pendingData?.questions?.length && (
                    <button
                      className="nextBtnQue"
                      style={{
                        backgroundColor: checkQuestion ? "#f77f00" : "#ffa03a",
                        cursor: checkQuestion ? "pointer" : "not-allowed",
                      }}
                      disabled={!checkQuestion || nextButtonDisabled}
                      onClick={() => {
                        setOpenConfirmPopup(true);
                        setQuestionNoAdaptive();
                      }}
                    >
                      Submit
                    </button>
                  )}
              </div>
            </div>
          </div>

          {adaptive ? null : (
            <div className="mt-3 d-flex gap-2" style={{ overflowX: "auto" }}>
              {pendingData?.questions?.length > 0 &&
                pendingData.questions.map((item, index) => {
                  // check if this index is in unanswered array
                  const isUnanswered = unAnsweredQs.some(
                    (q) => q.index === index,
                  );

                  return (
                    <div
                      key={index}
                      onClick={() => {
                        setQuestionNo(index);
                        checkUnanswered();
                      }}
                      className={
                        isUnanswered
                          ? "QuestionNoAnswerQs" // ✅ unanswered ka special class
                          : questionNo > index
                            ? "QuestionActiveNo"
                            : "QuestionNoNonActive"
                      }
                      style={{
                        borderColor: isUnanswered
                          ? "#FFE100" // ✅ unanswered ka border
                          : item.is_mandatory
                            ? "#AC1616"
                            : questionNo === index
                              ? "#F99933"
                              : questionNo > index
                                ? "#F77F00"
                                : "#668598",

                        color: isUnanswered
                          ? "#F77F00" // ✅ unanswered text color
                          : questionNo === index
                            ? "#F99933"
                            : questionNo > index
                              ? "#F77F00"
                              : "#668598",

                        backgroundColor: isUnanswered
                          ? "#FFE100" // ✅ unanswered background (light yellow)
                          : questionNo > index
                            ? "#FEF2E5"
                            : "transparent",

                        minWidth: "30px",
                      }}
                    >
                      Q{index + 1}
                    </div>
                  );
                })}

              {/* {pendingData?.questions?.length > 0 && adaptive &&
                  pendingData?.adaptiveQuiz.questionPool?.map((item, index) => (
                    <div
                      className={
                        pendingData?.adaptiveQuiz.usedQuestions.includes(item.no)
                          ? "QuestionActiveNo"
                          : "QuestionNoNonActive"
                      }
                      style={{
                        borderColor: "#F77F00",
                        backgroundColor:
                          !(pendingData?.adaptiveQuiz.usedQuestions.includes(item.no)) ? "#FEF2E5" : "#00FF00",
                        minWidth: "30px",
                      }}
                    >
                      {adaptive ? null : (`Q${index + 1}`)}
                      Q{index}
                    </div>
                  ))
                } */}
            </div>
          )}
          <div className="mt-4 allquestionTypesContainer row">
            {/* {list[questionNo].type === "Img Type" && (
          <ImgType questionNo={questionNo + 1} />
        )}
        {list[questionNo].type === "Video Type" && (
          <VideoType questionNo={questionNo + 1} />
        )}
        {list[questionNo].type === "Camera Type" && (
          <CameraType questionNo={questionNo + 1} />
        )}
        {list[questionNo].type === "TextArea Type" && (
          <TextareaType questionNo={questionNo + 1} />
        )}
        {list[questionNo].type === "Pdf Type" && (
          <PdfType questionNo={questionNo + 1} />
        )}
        {list[questionNo].type === "Checkbox Type" && (
          <CheckBoxType questionNo={questionNo + 1} />
        )}
        {list[questionNo].type === "Upload Type" && (
          <SubmisshionByUpload questionNo={questionNo + 1} />
        )} */}
            <div className={`${adaptive ? "col-8" : "col-12"}`}>
              {questionsAnswer.length > 0 &&
              !pendingData?.questions[questionNo]?.type?.is_manually_graded ? (
                <CheckBoxType
                  questionNo={
                    pendingData?.adaptiveQuiz?.currentQuestion?.no ||
                    questionNo + 1
                  }
                  question={
                    pendingData?.questions[
                      pendingData?.adaptiveQuiz?.currentQuestion?.no ||
                        questionNo
                    ]
                  }
                  setQuestionsAnswer={setQuestionsAnswer}
                  questionsAnswer={questionsAnswer}
                  adaptive={adaptive}
                  setCheckQuestion={setCheckQuestion}
                />
              ) : (
                <SubmisshionByUpload
                  questionNo={
                    pendingData?.adaptiveQuiz?.currentQuestion?.no ||
                    questionNo + 1
                  }
                  question={
                    pendingData?.questions[
                      pendingData?.adaptiveQuiz?.currentQuestion?.no ||
                        questionNo
                    ]
                  }
                  setQuestionsAnswer={setQuestionsAnswer}
                  questionsAnswer={questionsAnswer}
                  adaptive={adaptive}
                />
              )}
            </div>
            {adaptive && (
              <div className="col-4" style={{ marginTop: "100px" }}>
                {
                  <div className="d-flex gap-2">
                    <VerticalProBarPending
                      key="Difficulty"
                      title="Difficulty"
                      levels={difficultyLevels}
                      progress={difficulty * 20}
                    />
                    <VerticalProBarPending
                      key="Skills"
                      title="Skills"
                      levels={skillsLevels}
                      progress={skillsValue * 16.67}
                    />
                  </div>
                }
              </div>
            )}

            <div>
              {adaptive ? null : (
                <div className=" MarkAndQueContainerAssignment ">
                  <div className="quesHeading d-flex justify-content-start">
                    {/* 01 / 25 */}
                    {questionNo + 1}/{pendingData?.questions?.length}
                  </div>
                  <div className="">
                    <span className="subTitles TMTQ">Full Marks: </span> &nbsp;
                    <span className="quesHeading">
                      {pendingData?.questions[questionNo].correct_score}
                    </span>
                  </div>
                  <div className="">
                    <span className="subTitles TMTQ">Total Marks: </span> &nbsp;
                    <span className="quesHeading">
                      {pendingData?.total_marks}
                    </span>
                  </div>
                  <div className="">
                    <span className="subTitles TMTQ">Question Count: </span>{" "}
                    &nbsp;
                    <span className="quesHeading">
                      {pendingData?.total_questions}
                    </span>
                  </div>
                </div>
              )}
              <div className="nextBtnContainerAssignment">
                {!adaptive && questionNo >= 1 && (
                  <button
                    className="PreviousBtnQue mr-3"
                    onClick={(e) => setQuestionNo(questionNo - 1)}
                  >
                    Previous
                  </button>
                )}

                {!adaptive &&
                  questionNo < pendingData?.questions?.length - 1 && (
                    <button
                      className="nextBtnQue"
                      disabled={nextButtonDisabled}
                      onClick={(e) => {
                        setQuestionNo(questionNo + 1);
                        checkUnanswered();
                      }}
                    >
                      Next
                    </button>
                  )}
                {adaptive &&
                  pendingData?.adaptiveQuiz.usedQuestions.length <
                    pendingData?.questions.length && (
                    <button
                      style={{
                        backgroundColor: checkQuestion ? "#f77f00" : "#ffa03a",
                        cursor: checkQuestion ? "pointer" : "not-allowed",
                      }}
                      className="nextBtnQue"
                      disabled={!checkQuestion || nextButtonDisabled}
                      onClick={(e) => {
                        setQuestionNoAdaptive();
                        if (!adaptive) {
                          checkUnanswered();
                        }
                      }}
                    >
                      Next
                    </button>
                  )}
              </div>
            </div>
          </div>
          {isGettingData ? (
            <img
              className="ongoing_loader"
              src="/gif/LoaderDot.gif"
              alt=""
              style={{
                position: "absolute",
                left: "-40px",
                top: "280px",
                width: "120px",
              }}
            />
          ) : (
            allQuestion.sucessful && (
              <SucessfullySubmited
                handleQuestionfalse={handleQuestionfalse}
                handleSucessfulyfalse={handleSucessfulyfalse}
                refreshPage={refreshPage}
              />
            )
          )}
          {openConfirmPopup && (
            <ConfirmationPopup
              unAttemptedTitles={unAttemptedTitles}
              setOpenConfirmPopup={setOpenConfirmPopup}
              handleSubmitAdaptive={handleSubmitAdaptive}
              autoEvaluated={autoEvaluated}
              adaptive={adaptive}
              handleAutoEvaluatedSubmit={handleAutoEvaluatedSubmit}
              handleSubmit={handleSubmit}
              nextButtonDisabled={nextButtonDisabled}
              setUnAnsweredPopup={setUnAnsweredPopup}
            />
          )}
        </div>
      )}

      {didPressExit && (
        <ExitFullScreenPopup
          toggleFullScreen={toggleFullScreen}
          handleSubmit={handleSubmit}
          setDidPressExit={setDidPressExit}
          handleSubmitAdaptive={handleSubmitAdaptive}
          autoEvaluated={autoEvaluated}
          adaptive={adaptive}
          handleAutoEvaluatedSubmit={handleAutoEvaluatedSubmit}
          nextButtonDisabled={nextButtonDisabled}
        />
      )}
      {unAnsweredPopup && (
        <SubmittingWithoutAnsweringPopup
          didPressExit={didPressExit}
          setOpenConfirmPopup={setOpenConfirmPopup}
          setUnAnsweredPopup={setUnAnsweredPopup}
          questionsAnswer={questionsAnswer}
          userId={userId}
          assessmentId={assessmentId}
          unAttemptedTitles={unAttemptedTitles}
          handleSubmit={handleSubmit}
          handleSubmitAdaptive={handleSubmitAdaptive}
          autoEvaluated={autoEvaluated}
          adaptive={adaptive}
          handleAutoEvaluatedSubmit={handleAutoEvaluatedSubmit}
        />
      )}
      {mandetoryPopup && (
        <MandetoryUnAnsweredPopup setMandetoryPopup={setMandetoryPopup} />
      )}
      {unAuthPopup && (
        <UnAuthAssessmentPopup
          setUnAuthPopup={setUnAuthPopup}
          errMsg={errMsg}
        />
      )}
      {openstartAssesmentPopup && (
        <Dialog open={openstartAssesmentPopup}>
          <DialogTitle>Assessment Started</DialogTitle>
          <DialogContent>
            <Typography>
              Your assessment has started. Click OK to continue.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setOpenstartAssesmentPopup(false);
                toggleFullScreen();
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Dialog open={openBlurPopup} disableEscapeKeyDown>
        <DialogTitle>Do Not Switch Tabs</DialogTitle>
        <DialogContent>
          <Typography>
            You switched away from the exam window. Click OK to return to
            fullscreen.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenBlurPopup(false);
              toggleFullScreen(); // fullscreen + lockdown again after click
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
